module.exports = {"TXTWCL_Each_Way":{"id":"TXTWCL_Each_Way","defaultMessage":"Победа/место"}}